'use client';

import { ListFragment } from '@/gql/contentful-api/graphql';
import { Icon, List, Text } from '@/lib/mx-asurion-ui-react';
import { ICON_SRC_MAP } from '@/utils/icon-src-conversion';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

export const UnorderedList = ({ list }: { list: ListFragment }) => {
  const [isClient, setIsClient] = useState(false);

  /**
   * Because AUI Icons utilize a CDN to hydrate the svg rendered in the dom this
   * causes a hydration mismatch on the pre-rendered server and the client-side
   * browser.
   *
   * Added this useEffect as a suggested strategy to solve the hydration
   * mismatch error Read more here:
   * https://nextjs.org/docs/messages/react-hydration-error#solution-1-using-useeffect-to-run-on-the-client-only
   */
  useEffect(() => {
    setIsClient(true);
  }, []);

  const header = list.header && (
    <Text size={4} weight="feather">
      {list.header}
    </Text>
  );

  const subHeader = list.subHeader && (
    <div className="mt-3">
      <Text weight="feather">{list.subHeader}</Text>
    </div>
  );

  const footer = list.footer && (
    <Text size={1} weight="feather">
      {list.footer}
    </Text>
  );

  return isClient ? (
    <div className="pb-4 pt-6">
      {list.header && header}
      {list.subHeader && subHeader}
      <List as="ul" alignment="top">
        {list.listItemsCollection?.items.map((item) =>
          item != null ? (
            <List.Item key={item.sys.id} className="!bg-transparent">
              {item.icon && (
                <List.Item.Leading>
                  <Icon.SSR
                    size="large"
                    src={ICON_SRC_MAP[item.icon] ?? item.icon}
                  />
                </List.Item.Leading>
              )}
              {item.title && (
                <List.Item.Heading>{item.title}</List.Item.Heading>
              )}
              {item.content && (
                <List.Item.SupportiveText
                  className={
                    list.listItemSupportiveTextClassname != null
                      ? clsx(list.listItemSupportiveTextClassname)
                      : '!text-base !font-normal !text-[#1A1C1E]'
                  }
                >
                  {item.content}
                </List.Item.SupportiveText>
              )}
            </List.Item>
          ) : null,
        )}
      </List>
      {list.footer && footer}
    </div>
  ) : null;
};
